import { ChangeEvent } from "react";
import { Item } from "../ui-kit";
import { DateTime } from "luxon";
import { CurrencyItem } from "../../constants/currencies";

export enum SearchFieldType {
  TEXT = "text",
  DATE = "date",
  DATE_RANGE = "dateRange",
  AMOUNT = "amount",
  AMOUNT_RANGE = "amountRange",
  DROPDOWN = "dropdown",
  CREATED_BY_DROPDOWN = "createdByDropdown",
  CATEGORY_DROPDOWN = "categoryDropdown",
  ORDER_TAG_DROPDOWN = "orderTagDropdown",
  CUSTOMER_TAG_DROPDOWN = "customerTagDropdown",
  SUPPLIER_DROPDOWN = "supplierDropdown",
  BRAND_DROPDOWN = "brandDropdown",
  ROLE_DROPDOWN = "roleDropdown",
  PICKER_DROPDOWN = "pickerDropdown",
  LOCATION_DROPDOWN = "locationDropdown",
  TERMINAL_DROPDOWN = "terminalDropdown",
  SHIPPING_COMPANY_DROPDOWN = "shippingCompanyDropdown",
  COMMERCIAL_INVOICE_MODE_OF_TRANSPORT_DROPDOWN = "commercialInvoiceModeOfTransportDropdown",
  COMMERCIAL_INVOICE_COUNTRY_OF_ORIGIN_DROPDOWN = "commercialInvoiceCountryOfOriginDropdown",
  SEARCH_BY_MERCHANT_DROPDOWN = "searchByMerchantDropdown",
  CURRENCY_DROPDOWN = "currencyDropdown",
  CHECKBOX = "checkbox",
  CHECKBOX_ARCHIVED = "checkboxArchived",
}

export type GenericEvent =
  | ChangeEvent<HTMLInputElement>
  | DateTime
  | Item
  | CurrencyItem
  | undefined;

export interface ISearchFieldConfig {
  type: SearchFieldType;
  key: string;
  rangeEndKey?: string;
  label: string;
  placeholder?: string;
  rangeEndPlaceholder?: string;
  dropdownValues?: Item[];
}

export interface IAdvancedSearchProps {
  config: ISearchFieldConfig[];
  onChange: (filters: Record<string, any>) => void;
  className?: string;
  isLive?: boolean;
  defaultOpen?: boolean;
  restoredValues?: any;
  withoutFilterButton?: boolean;
  externalCurrentCurrency?: CurrencyItem;
  externalCurrencyItems?: CurrencyItem[]; // this is needed if the company context is called in a modal window
  disableCurrencyDropdown?: boolean;
  withoutItemAllLocations?: boolean;
  externalLocationItem?: Item;
  disableLocationDropdown?: boolean;
  externalLocations?: Item[];
}
